'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import l from "../defs/Gear.es.js";
const o = a.forwardRef((r, a$1) => /* @__PURE__ */ a.createElement(p, { ref: a$1, ...r, weights: l }));
o.displayName = "GearIcon";
const n = o;
export {
  n as Gear,
  o as GearIcon
};
